import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue'
import CabinetSidebarMenuSection from './SidebarMenuSection.vue'

import type { SidebarSection } from './index'
interface Props {
  condensed: boolean
  sections: SidebarSection[]
  dropdownMenu?: boolean
  opened: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuContainer',
  props: {
    condensed: { type: Boolean },
    sections: {},
    dropdownMenu: { type: Boolean },
    opened: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const slots = useSlots()

const classes = computed(() => ({
  'cabinet-sidebar-menu': true,
  'is-condensed': props.condensed,
}))

const __returned__ = { props, slots, classes, computed, useSlots, CabinetSidebarMenuSection }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})